/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type TabBarContainer_viewer = {
    readonly role: USER_ROLE;
    readonly " $refType": "TabBarContainer_viewer";
};
export type TabBarContainer_viewer$data = TabBarContainer_viewer;
export type TabBarContainer_viewer$key = {
    readonly " $data"?: TabBarContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '47ab60fc7757d42adc7e93bc3c4179f6';
export default node;
